import { render, staticRenderFns } from "./TxProductViewport.vue?vue&type=template&id=60844fe8&scoped=true&"
import script from "./TxProductViewport.vue?vue&type=script&lang=js&"
export * from "./TxProductViewport.vue?vue&type=script&lang=js&"
import style0 from "./TxProductViewport.vue?vue&type=style&index=0&id=60844fe8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60844fe8",
  null
  
)

export default component.exports